module.exports = __webpack_public_path__ + "media/images/landingAnimation-5211de63127b539564bc54b251cfac24.gif";